/* */ 
module.exports = System._nodeRequire ? System._nodeRequire('util') : require('util');